module.exports = __webpack_public_path__ + "static/media/vector-up.00c4119a.svg";